import { Price } from '../../../types/interfaces';
import { findPriceForQuantity } from './findPriceForQuantity';

export function getPriceInRange(product: { prices: Price[] } | null | undefined, quantity = 1) {
  if (!product) {
    return { price: null };
  }

  const price = findPriceForQuantity(product.prices, quantity);
  if (price === 0) {
    return { price: null };
  }

  const match = product.prices.find(
    (p) =>
      quantity >= p.price_type.range_start &&
      quantity <= p.price_type.range_end
  );

  return match && match.price > 0 ? match : { price };
}
